import { useToast } from 'vue-toastification'

const toast = useToast()

export function showSuccessMessage(message) {
  if (message) {
    toast.success(message, {
      timeout: 3000
    })
  }
}

export function showErrorMessage(message = 'Something went wrong') {
  toast.error(message, {
    timeout: 4000
  })
}

export function showInfoMessage(message) {
  if (message) {
    toast.info(message, {
      timeout: 3000
    })
  }
}
